import type { ColDef, IProvidedFilterParams } from 'ag-grid-community';
import type { IntlKey } from 'locales';
import { useMemo } from 'react';

import { useHeaderValueGetter } from './useHeaderValueGetter';

const defaultCustomization = {};
export function useDefaultColumnDefinition<T>(
  getHeaderIntlKey: (columnName: string) => IntlKey,
  customization: Partial<ColDef<T>> = defaultCustomization,
): ColDef<T> {
  const headerValueGetter = useHeaderValueGetter(getHeaderIntlKey);
  return useMemo<ColDef<T>>(
    () => ({
      enableCellChangeFlash: true,
      headerValueGetter,
      sortable: true,
      resizable: true,
      floatingFilter: true,
      filterParams: {
        buttons: ['reset'],
        closeOnApply: true,
        debounceMs: 200,
      } satisfies Partial<IProvidedFilterParams>,
      minWidth: 70,
      sortingOrder: ['asc', 'desc', null],
      width: 110,
      cellStyle: params => {
        if (params.colDef.editable) {
          return { cursor: 'pointer' };
        }
      },
      ...customization,
    }),
    [customization, headerValueGetter],
  );
}
